import { useEffect, useState } from 'react'
import { CustomEventName } from 'src/constant'

import commonRepo from '@/repository/common.repo'
import BannerService from '@/service/banner.service'

const TIMEOUT_MAX_MS = 2147483647

export const useBanner = () => {
  const [init, setInit] = useState(false)

  useEffect(() => {
    if (!commonRepo.user) return

    BannerService.handleInitBanner(commonRepo.user, commonRepo.isSchoolflat)
    setInit(true)
  }, [commonRepo.user, commonRepo.isSchoolflat])

  useEffect(() => {
    if (!init) return

    if (!BannerService.banner?.expiredAt) {
      return
    }

    const timeDiff = (() => {
      // setTimeout의 time의 최댓값(2^32) 방어 코드
      const _timeDiff = BannerService.banner.getNowAndExpiredAtDiff()
      return _timeDiff <= TIMEOUT_MAX_MS ? _timeDiff : TIMEOUT_MAX_MS - 1
    })()

    const handleOnTimeout = () => {
      dispatchEvent(new CustomEvent(CustomEventName.Banner.onExpired))

      if (commonRepo.user) {
        BannerService.shiftNextBanner()
        BannerService.handleFetchNextBanner(commonRepo.user, commonRepo.isSchoolflat)
      }
    }

    if (timeDiff < 1000) {
      handleOnTimeout()
      return
    }

    const timeout = setTimeout(handleOnTimeout, timeDiff)

    return () => {
      clearTimeout(timeout)
    }
  }, [BannerService.banner?.expiredAt, init])
}
